import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({ 
  show, 
  title = "Confirm Action",
  message, 
  onConfirm, 
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "warning" // "warning" for orange, "danger" for red
}) => {
  const brandOrange = "#F16D09";
  const brandRed = "#dc3545";
  
  const headerColor = variant === "danger" ? brandRed : brandOrange;
  
  return (
    <>
      <style>{`
        .modal-backdrop.show {
          z-index: 10049 !important;
        }
        .modal.show {
          z-index: 10050 !important;
        }
      `}</style>
      <Modal 
        show={show} 
        onHide={onCancel} 
        centered
      >
      <Modal.Header style={{ backgroundColor: headerColor, color: 'white', border: 'none' }}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '1.5rem', fontSize: '1.1rem' }}>
        {message}
      </Modal.Body>
      <Modal.Footer style={{ border: 'none', padding: '1rem 1.5rem' }}>
        <Button 
          variant="secondary" 
          onClick={onCancel}
          style={{ minWidth: '100px' }}
        >
          {cancelText}
        </Button>
        <Button 
          style={{ 
            backgroundColor: headerColor, 
            border: 'none',
            minWidth: '100px'
          }}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default ConfirmModal;
